<template>
  <b-container class="home-view pt-4" fluid>
    <h1>{{ $t("title.home") }}</h1>
    <b-card-group columns>
      <b-card v-for="(link, index) in links" :key="index" no-body class="overflow-hidden">
        <router-link :to="'/' + link.url">
          <b-row no-gutters>
            <b-col md="2">
              <font-awesome-icon :icon="link.icon" size="3x" />
            </b-col>
            <b-col md="10">
              <b-card-body>
                {{ $t("title." + link.url) }}
              </b-card-body>
            </b-col>
          </b-row>
        </router-link>
      </b-card>
    </b-card-group>
  </b-container>
</template>

<script>
import { HOME } from "@/router/routeNames";
export default {
  name: HOME,
  data() {
    return {
      links: [
        { url: "operations_periodical", icon: "table" },
        { url: "operations_daily", icon: "table" },
        { url: "operations_hourly", icon: "table" },
        { url: "operations_compare", icon: "table" },
        { url: "accounting", icon: "table" },
        { url: "smart_touch_maintenance", icon: "wrench" },
        { url: "operations_expired", icon: "table" },

        { url: "events_accounting", icon: "birthday-cake" },
        { url: "business_events_order", icon: "birthday-cake" },
        { url: "business_events_order_simple", icon: "birthday-cake" },
        { url: "business_events_presta", icon: "birthday-cake" },
        { url: "business_events_presta_simple", icon: "birthday-cake" },
        { url: "cake", icon: "birthday-cake" },

        { url: "kiosk_global", icon: "store" },
        { url: "kiosk_global_Updated", icon: "store" },
        { url: "kiosk_compare", icon: "balance-scale-right" },

        { url: "games", icon: "gamepad" },
        { url: "games_code", icon: "gamepad" },
        { url: "games_simple", icon: "gamepad" },
        { url: "games_compare", icon: "balance-scale-right" },
        { url: "staff", icon: "user" },
        { url: "staffHistory", icon: "user" },

        { url: "snacking", icon: "cookie-bite" },
        { url: "merchandising", icon: "shopping-cart" },

        { url: "cards", icon: "credit-card" },
        { url: "onmniplay_report", icon: "table" },
        { url: "consumption_report", icon: "table" },
        { url: "azure_cost", icon: "cloud" },
      ],
    };
  },
};
</script>
